import React from "react";

import { StyledTwBackground } from "./styled";

const TwBackground = ({ styles, children }) => (
  <StyledTwBackground styles={styles}>{children}</StyledTwBackground>
);

export default TwBackground;
